const { validator } = require("./utils/validation");

module.exports = {
  async test({ rule, fqAppId, resolveValue }) {
    const property = rule.property;

    try {
      let value = await resolveValue(rule.fqAppId || fqAppId, rule.setting);
      if (property) {
        value = value?.[property];
      }

      return value === rule.equals;
    } catch (e) {
      return false;
    }
  },

  validate: validator({
    "Rule's `fqAppId` property must be a string": rule => !rule.fqAppId || typeof rule.fqAppId === 'string',
    'Rule must have a `setting` property': rule => 'setting' in rule,
    "Rule's `setting` property must be a string": rule => typeof rule.setting === 'string',
    'Rule must have an `equals` property': rule => 'equals' in rule,
    "Rule's `equals` property must be a primitive value": rule =>
      rule.equals === null
      || ['string', 'number', 'boolean'].includes(typeof rule.equals),
    "Rule's `property` property must be a string or number":
      rule => !rule.property
      || ['string', 'number'].includes(typeof rule.property)
  })
};
